module.exports = __webpack_public_path__ + "static/img/case_tab_01.9df9fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_01.png
// module id = Em60
// module chunks = 34